"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FavoriteProjectsService = (function () {
    function FavoriteProjectsService(sessionService) {
        var _this = this;
        this.ToggleFavoriteProject = function (projId) {
            if (_this.sessionService.isSupported) {
                var projectFavorites_1 = _this.sessionService.get(FavoriteProjectsService.localStorageKey);
                if (projectFavorites_1 == null) {
                    projectFavorites_1 = [];
                }
                var indexesToRemove_1 = [];
                //create a list of indexes to remove
                projectFavorites_1.forEach(function (item, index, items) {
                    if (item == projId) {
                        indexesToRemove_1.push(index);
                    }
                });
                if (indexesToRemove_1.length > 0) {
                    //REMOVE
                    indexesToRemove_1.reverse().forEach(function (item, index, items) {
                        projectFavorites_1.splice(item, 1);
                    });
                }
                else {
                    // ADD
                    if (projectFavorites_1.length >= FavoriteProjectsService.maxFavoriteProjects) {
                        return;
                    }
                    projectFavorites_1.push(projId);
                }
                _this.sessionService.set(FavoriteProjectsService.localStorageKey, projectFavorites_1);
            }
        };
        this.GetFavoriteProjects = function () {
            if (_this.sessionService.isSupported) {
                var projectFavorites = _this.sessionService.get(FavoriteProjectsService.localStorageKey);
                if (projectFavorites == null || projectFavorites.length == 0)
                    return null;
                return projectFavorites;
            }
            return null;
        };
        this.IsFavorite = function (projId) {
            var favoriteProjects = _this.GetFavoriteProjects();
            if (favoriteProjects == null)
                return false;
            for (var i = 0; i < favoriteProjects.length; i++) {
                if (projId == favoriteProjects[i])
                    return true;
            }
            return false;
        };
        this.sessionService = sessionService;
    }
    return FavoriteProjectsService;
}());
FavoriteProjectsService.$inject = ['sessionService'];
FavoriteProjectsService.localStorageKey = "projectFavorites";
exports.FavoriteProjectsService = FavoriteProjectsService;
//# sourceMappingURL=FavoriteProjectsService.js.map



// WEBPACK FOOTER //
// ./src/services/favoriteProjectsService.js